export const VERTICES_AMOUNT = 750
export const NOISE_SCALE = 450 // the higher the softer
export const Z_SPEED = 0.00001 // noise change per frame
export const MOUSE_FORCE = -5 // positive 'push', negative 'pull'
export const MIN_OPACITY = 0.35
export const MAX_OPACITY = 0.75
export const MIN_WIDTH_TO_RUN = 550
